module.exports = __webpack_public_path__ + "static/media/non-invasive.a93b02f9.svg";